import { put, select, fork, take, race } from "redux-saga/effects";
import {
  ADD_ATTACHMENT_REQUEST,
  GET_SIGNED_URL_SUCCESS,
  GET_SIGNED_URL_FAIL,
  UPLOAD_ATTACHMENTS_COMPLETED,
} from "./actionTypes";
import { getSignedUrl } from "./actionCreators";
import { dispatchGeneratorFunc } from "../helpers/helpers";
import { getAuth } from "./selectors";

export function* addAttachmentFlow() {
  /*
   * Returns the pre-signed put URL and public read URL for the attachment that is about to be uploaded
   */
  while (true) {
    const { attachment } = yield take(ADD_ATTACHMENT_REQUEST);

    const { user } = yield select(getAuth);

    // Get Signed URL action
    yield fork(
      dispatchGeneratorFunc,
      getSignedUrl,
      user,
      attachment.id,
      attachment.fileName,
      attachment.fileType
    );

    const { success } = yield race({
      success: take(GET_SIGNED_URL_SUCCESS),
      fail: take(GET_SIGNED_URL_FAIL),
    });

    if (success) {
      yield put({ type: UPLOAD_ATTACHMENTS_COMPLETED });
    }
  }
}
